import { createFileRoute } from '@tanstack/react-router';

import { getTeamMemberQueryOption } from '@/_pages/team-members/api-service';
import Loading from '@/_pages/team-members/preference/loading';

export const Route = createFileRoute('/_private/team-members/_template/$id/preference')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getTeamMemberQueryOption(opts.params.id)),
  staticData: {
    pageTitle: 'Preference',
    tabKey: 'team-member/preference',
  },
  pendingComponent: Loading,
});
